module.exports = __webpack_public_path__ + "media/flags/gb-wls-3facef5a.svg";